import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom'
import Aboutuslearners from '../Landing/Subcomponent/aboutuslearners';
import Aluminicompany from '../Landing/Subcomponent/aluminicompany';
import Whyedu from '../Landing/Subcomponent/whyedu';
import "../../css/course-page.css";

class Onlinesybersecuritycertification extends Component {
    render() {
        return (
            <div>
                    <div aria-label="breadcrumb">
                        
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><Link ><FontAwesomeIcon icon={faHome} />  &nbsp; HOME</Link></li>
                             <li class="breadcrumb-item active">Online Cyber Security Certification</li>
                        </ol>
                    </div>

                    <section class="course-header bg-blue1" id="course-header">
                            <div class="row">
                                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6">
                                <h1>Online Cyber Security Certification</h1>
                                    <p>Be aware,be secure!!</p>
                                    <br /><br />
                                    <div class="row">
                                    <button class="pulse-button" type="button" data-toggle="modal"  data-target="#myModalq" onclick="startvideo()"></button>
                                    <p class="Watch-Intro">Watch Intro Video </p>
                                </div><br />
                                <div class="form-group">
                                    <a href="#apply-now" class="btn btn-md enroll-btn">Enroll Now </a>
                                       
                                        <button type="button" class="btn btn-md download-bro-btn" data-toggle="modal" id="myBtn"
                                            data-target="#myModal"  >Download
                                            brochure</button><br />  <br /> <br />   
                                        </div>
                                </div>
                                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-1"></div>
                                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-5">
                                    <p>Jointly Delivered by </p>
                                    <ul>
                                        <li><img width="" src="/assets/images/epn.svg" alt=""/></li>
                                        <li >Seema Dixit</li> 
                                    </ul>
                                    <br />
                                </div>
                            </div>
                        </section> 
                        <div class="course-main-contains def-z" id="Description" >
                            <div class="card">
                                <div class="row contanint-display">
                                    <div class="col-lg-4 col-xl-4 col-12 col-sm-12 col-md-4">    
                                    <b>What's included : <br />
                                    <i class="fa fa-mobile" ></i> &nbsp;&nbsp;Mobile Support</b>  
                                    </div>
                                    <div class="col-lg-4 col-xl-4 col-12 col-sm-12 col-md-4">    
                                    <b><i class="fa fa-comments" ></i>&nbsp; Discussion Forum</b><br />
                                    <b><i class="fa fa-certificate" ></i> &nbsp; Course Certificate</b>
                                    </div>
                                    <div class="col-lg-4 col-xl-4 col-12 col-sm-12 col-md-4" >    
                                    <b><i class="fa fa-question" ></i> &nbsp;&nbsp;&nbsp;Quiz</b><br />
                                   </div>
                                </div>
                            </div>
                        </div>


                        <section class="def-z">
                            <div class="header" id="myHeader">
                                    <ul>
                                        <li><a href="#Description">Description</a></li>
                                        <li><a href="#Features">Features </a></li>
                                        <li><a href="#Tools">Tools</a></li>
                                        <li><a href="#syllabus">Syllabus</a></li>            
                                        <li><a href="#Outcomes">Learning Outcomes</a></li>           
                                        <li><a href="#Reviews">Learner Review </a></li>          
                                        <li><a href="#Instructor">About Instructor</a></li>    
                                        <li class="btn-header cs-dx"><a href="#apply-now">Enroll Now</a></li>         
                                    </ul>
                            </div>
                        </section>

                        <section class="course-description" id="course-description">
                            <br />
                            <div class="row">
                                <div class="col-sm-12">
                                    <h3 class="heading-tab">What Is Cyber Security Course</h3>
                                    <p align="justify">The online cyber security certification course is designed to increase the awareness of different types of threats, attacks, and cybercrimes on the internet. This course is highly recommended amongst the available cyber security courses in India. The cyber security certification training opens its doors to various career opportunities. Learn cyber security online by a professional trainer who has more than 10 years of experience in conducting training in security domains like network security, ethical hacking, penetration testing, and cybersecurity and get certified from edu plus now, Pune.</p>
                                </div>
                                
                                <div class="col-1"> </div>
                            </div> 
                            <br />
                            <div class="row">
                                <div class="col-sm-12">
                                    <h3 class="heading-tab" >Introduction To Cyber Security Course</h3>
                                    <p align="justify" id="Features">The cyber security online course has been constituted for educational purposes only. The online cyber security classes start off with the basics of operating system, networking and virtualization, and then introduce you to various security threats and attacks. You will then be provided with the knowledge to protect your privacy and security on the internet. You will also learn how to secure your data using various tools and techniques.
                                    <br />The course further covers simple data backup, restore, and recovery techniques. You will also learn how to securely use your computer while connecting to the internet by using proper browser security settings and personal firewall. This course prepares you to build your career in the cyber security field.
                                    </p>
                                </div>
                            
                                <div class="col-1"> </div>
                            </div> 
                 <br />         
                <div class="row">
                     <div class="col-sm-12">
                         <h3 class="heading-tab">Key Features Of The Cyber Security Course</h3>
                         <p align = "justify">
                         <ul class="highlight-ss">
                         <li>	Mentorship by one of the best in business, Seema Dixit.</li>
                         <li>	One of the best cyber security courses in Pune that provides online classes and seamless EMI options.</li>
                         <li>	Course awarded by edu plus now, Pune.</li>
                         </ul>
                         </p>
                     </div>
                    
                     <div class="col-1"> </div>
                 </div> 
                 <br />
                 <div class="row">
                     <div class="col-sm-12">
                         <h3 class="heading-tab">Who Will Benefit From The Cyber Security Training Course ?</h3>
                     </div>
                 </div>
                 <div class="row">

                     <div class="col-sm-6">
                         <ul class="highlight-ss">
                             <li>	This cyber security certification training course is for employees in a company who want to be trained on how to protect their sensitive customer data and network from hackers.</li>
                             <li>	This course is ideal for employees who need to be trained as part of the annual Cyber Security Awareness Training requirements.</li>
                             <li>	Anyone who uses a computer or smartphone with an internet connection and wants to be secured from the cyber world.</li>
                         </ul>
                     </div>

                     <div class="col-sm-6">
                         <ul class="highlight-ss">
                             <li>	Someone who wants to be able to browse the internet securely without being tracked by marketing companies.</li>
                             <li  id="Tools">	Anyone who wants to build a career in the domain of information security or cyber security.</li>
                         </ul>
                     </div>

                 </div><br />
                 <h2> Tools Covered</h2><br />
                     <div class="row">
                     <div class="col-md-3 col-sm-12">
                        <div class="card cards-singles">
                        <center id="syllabus"><img src="/assets/images/icons/virtualbox.svg" alt="Virtual Box" />  </center>
                     </div>
                     </div>
                     <div class="col-md-3 col-sm-12">
                        <div class="card cards-singles">
                        <center><img src="/assets/images/icons/kali-linux-logo-b.png" alt="Kali Linux"  /> </center>
                     </div>
                     </div>
                     <div class="col-md-3 col-sm-12">
                        <div class="card cards-singles">
                        <center><img src="/assets/images/icons/wireshark-logo-b.png" alt="Wireshark" /> </center>
                     </div>
                     </div>
                  </div>
             </section>
             <section class="course-syllabus " id="course-syllabus">
             <div class="row">
                  <div class="col-sm-12 col-md-12 col-lg-12 col-xl-10" >
                         <h3> Syllabus </h3>
                         <br />
                         <div class="syl-bg">
                         <div id="de_syllabus">
                             <div class="panel-group">
                                 <div class="panel panel-info">
                                     <div class="panel-heading" id="de_heading1" data-toggle="collapse"
                                         href="#de_syllabus1" aria-expanded="true" aria-controls="de_syllabus1">
                                         <h6 class="panel-title">
                                             <i class="indicator fa fa-minus"></i> Introduction to Cyber Security, Operating System, Virtualization and Basic Networking 
                                         </h6>
                                     </div>

                                     <div id="de_syllabus1" class="collapse show" aria-labelledby="de_heading1"
                                         data-parent="#de_syllabus">
                                         <div class="panel-body">
                                             <ul class="syllabus-ul">
                                                 <li> Introduction to Cybersecurity awareness course</li>
                                                 <li> Introduction to Cybersecurity</li>
                                                 <li> Internet live statistics </li>
                                                 <li> Threatmap</li>
                                                 <li> Haveibeenpwned (Is your account safe) </li>
                                                 <li> CyberCrimes</li>
                                                 <li> Introduction to Operating System </li>
                                                 <li> Types of Servers </li>
                                                 <li> Installation of Operating system and virtualization </li>
                                                 <li> Installing Kali Linux and Virtual Box </li>
                                                 <li> Downloading Prebuilt Kali Linux machine and kali Linux iso image for virtualBox </li>
                                                 <li> Installing Prebuilt Kali Linux machine image in VMWare workstation Player </li>
                                                 <li> Installing Kali Linux using iso image in VirtualBox </li>
                                                 <li> Installing Windows 7 on VirtualBox </li>
                                                 <li> Introduction to Metasploitable Linux and how to download and open it in hypervisor</li>
                                                 <li> Installing Metasploitable Linux on VirtualBox </li>
                                                 <li> Introduction to Computer Network </li>
                                                 <li> Types of Network </li>
                                                 <li> Network Architecture </li>
                                                 <li> Computer Protocol </li>
                                                 <li> Computer Ports </li>
                                                 <li> IP Address </li>
                                                 <li> MAC Address </li>
                                                 <li> Basic Windows commands </li>
                                                 <li> Creating Network of virtual machines</li>
                                                 <li> Home Wi-Fi- Router and security </li>
                                             </ul>
                                         </div>
                                     </div>
                                 </div>
                               
                                 <div class="panel panel-info">
                                     <div class="panel-heading" id="de_heading2" data-toggle="collapse"
                                         href="#de_syllabus2" aria-expanded="true" aria-controls="de_syllabus2">
                                         <h6 class="panel-title">
                                             <i class="indicator fa fa-minus"></i> Quiz
                                         </h6>
                                     </div>

                                     <div id="de_syllabus2" class="collapse show" aria-labelledby="de_heading2"
                                         data-parent="#de_syllabus">
                                         <div class="panel-body">
                                             <ul class="syllabus-ul">
                                             </ul>
                                         </div>
                                     </div>
                                 </div>

                                
                                 <div class="panel panel-info">
                                     <div class="panel-heading" id="de_heading3" data-toggle="collapse"
                                         href="#de_syllabus3" aria-expanded="true" aria-controls="de_syllabus3">
                                         <h6 class="panel-title">
                                             <i class="indicator fa fa-minus"></i> Introduction to Ethical Hacking 
                                         </h6>
                                     </div>

                                     <div id="de_syllabus3" class="collapse show" aria-labelledby="de_heading3"
                                         data-parent="#de_syllabus">
                                         <div class="panel-body">
                                             <ul class="syllabus-ul">
                                                 <li> Introduction to Section-2 Ethical hacking</li>
                                                 <li> Ethical Hacking Terminologies</li>
                                                 <li> Phases of Ethical Hacking</li>
                                                 <li> Footprinting</li>
                                                 <li> Netcraft</li>
                                                 <li> Whois footprinting</li>
                                                 <li> Archive.org</li>
                                                 <li> Using Ping and tracert command</li>
                                                 <li> What is my ipaddress</li>
                                                 <li> Malicious links</li>
                                                 <li> IPLogger</li>
                                                 <li> google timeline</li>
                                                 <li> My activity tracker</li>
                                                 <li> Introduction to Section-2 -Scanning</li>
                                                 <li> TCP Three-Way handshake</li>
                                                 <li> Protocols and Ports</li>
                                                 <li> Port Scanners</li>
                                                 <li> Netstat</li>
                                                 <li> NMAP</li>
                                                 <li> Scanning Metasploitable Linux using tool Nmap</li>
                                                 <li> Gaining access, Maintaining access, covering tracks</li>
                                                 <li> Sniffers</li>
                                                 <li> Wireshark</li>
                                                 <li> Sniffing telnet traffic using wireshark</li>
                                                 <li> Using Armitage tool in kali to attack windows XP</li>
                                                 <li> Malwares and security</li>
                                                 <li> Keylogger</li>
                                                 <li> Bots and Botnets</li>
                                                 <li> DoS and DDoS attack</li>
                                                 <li> DoS Attack using LOIC tool</li>
                                                 <li> Social Engineering attacks</li>
                                                 <li> Phishing</li>
                                                 <li> Phishing using Kali Linux</li>
                                                 <li> Password Security</li>
                                                 <li> Password Attacks</li>
                                                 <li> How secure is my password</li>
                                                 <li> Password Guessing websites</li>
                                                 <li> MD5 hash generator and crackstation</li>
                                                 <li> Antivirus</li>
                                                 <li> Testing Antivirus using EICAR</li>
                                             </ul>
                                         </div>
                                     </div>
                                 </div>
                                
                                 <div class="panel panel-info">
                                     <div class="panel-heading" id="de_heading4" data-toggle="collapse"
                                         href="#de_syllabus4" aria-expanded="true" aria-controls="de_syllabus4">
                                         <h6 class="panel-title">
                                             <i class="indicator fa fa-minus"></i> Quiz 
                                         </h6>
                                     </div>

                                     <div id="de_syllabus4" class="collapse show" aria-labelledby="de_heading4"
                                         data-parent="#de_syllabus">
                                         <div class="panel-body">
                                             <ul class="syllabus-ul">
                                             </ul>

                                         </div>
                                     </div>
                                 </div>
                                 
                                 <div class="panel panel-info">
                                     <div class="panel-heading" id="de_heading13" data-toggle="collapse"
                                         href="#de_syllabus13" aria-expanded="true" aria-controls="de_syllabus13">
                                         <h6 class="panel-title">
                                             <i class="indicator fa fa-minus"></i>Introduction to Data/Information Security, Windows Security 
                                         </h6>
                                     </div>

                                     <div id="de_syllabus13" class="collapse show" aria-labelledby="de_heading13"
                                         data-parent="#de_syllabus">
                                         <div class="panel-body">
                                             <ul class="syllabus-ul">
                                             <li> Introduction to Section-3</li>
                                                 <li> Encryption and cryptography</li>
                                                 <li> Online Encryption using website Encipher it</li>
                                                 <li> Bitlocker drive encryption in Windows</li>
                                                 <li> Encryption using open source tool Veracrypt: Downloading and installing tool</li>
                                                 <li> Using veracrypt tool</li>
                                                 <li> Hash function</li>
                                                 <li> Hash Killer</li>
                                                 <li> Checking file integrity using onlinemd5.com</li>
                                                 <li> Steganography</li>
                                                 <li> Online steganography</li>
                                                 <li> Steganography tool: Xiao</li>
                                                 <li> Digital Signature</li>
                                                 <li> Introduction to Section-3 Operating system security and hardening</li>
                                                 <li> Windows 10 Security, Privacy and hardening settings</li>
                                                 <li> Firewall</li>
                                                 <li> IDS,IPS,Honeypot</li>
                                                 <li> Windows Firewall-Basic settings</li>
                                                 <li> Windows Firewall-Block Protocol http</li>
                                                 <li> Windows Firewall- Block Program</li>
                                                 <li> Browser Security</li>
                                                 <li> Mozilla Firefox Security</li>
                                                 <li> Internet Explorer Security Features-Security Zones</li>
                                                 <li> Internet Explorer Security Features-Do not Track</li>
                                                 <li> Internet Explorer Security Features-InPrivate Browsing</li>
                                                 <li> Internet Explorer Security Feature-Location tracking</li>
                                                 <li> Internet Explorer Security Feature-Pop-up Blocker</li>
                                                 <li> Google Chrome security settings</li>
                                                 <li> Email Security</li>
                                                 <li> Email Spoofing</li>
                                                 <li> Email Traching</li>
                                                 <li> Physical Security</li>
                                                 <li> How to locate lost smartphone</li>
                                                 <li> Windows 10 System image backup</li>
                                                 <li> Windows 10 backup and restore</li>
                                                 <li> Data recovery using Recuva-1</li>
                                                 <li> Data recovery using Recuva-2</li>
                                                 <li id="Outcomes"> Steps for Personal Security</li>
                                             </ul>
                                         </div>
                                     </div>
                                 </div>

                                 <div class="panel panel-info">
                                     <div class="panel-heading" id="de_heading6" data-toggle="collapse"
                                         href="#de_syllabus6" aria-expanded="true" aria-controls="de_syllabus6">
                                         <h6 class="panel-title">
                                             <i class="indicator fa fa-minus" ></i> Quiz 
                                         </h6>
                                     </div>

                                     <div id="de_syllabus6" class="collapse show" aria-labelledby="de_heading6"
                                         data-parent="#de_syllabus">
                                         <div class="panel-body">
                                             <ul class="syllabus-ul">
                                             </ul>
                                         </div>
                                     </div>
                                 </div>

                             </div> 
                         </div> 
                         </div> 
                     </div> 
                 </div> 
             </section>

             <section class="course-learning-outcome bg-secondary " id="course-learning-outcome">
                 <div class="row">
                     <div class="col-sm-6">
                         <h3>Learning Outcomes</h3>
                         <ul class="lo-ul">
                             <li>Students will learn basics of Operating System, Networking, Ethical Hacking, Information Security and Operating System hardening techniques.
                             </li>
                         </ul>
                         <br />
                         <h3>Assessment</h3>
                         <div class="table-responsive course-batch-schedule"> 
                            <div class="card">
                                <table class="table">
                                    <thead>
                                        <tr class="text-center">
                                            <th >Type</th>
                                            <th >Weightage %</th>
                                        </tr>
                                    </thead>
                                    <tbody class="content-size">
                                        <tr>
                                            <td >Content</td>
                                            <td id="Reviews">100%</td>
                                        </tr>
                                    </tbody>
                                </table>

                            </div>
                        </div>
                     </div>
                     <div class="col-sm-6">

                         <img src="/assets/images/icons/certificate1.png" alt="Online Cyber Security Certification" />
                     </div>
                 </div>
                 <br/><br />
             </section> 
             <section class="course-admission-process"> 
           
             </section>
             <Aboutuslearners />     
             <Aluminicompany />
            <section class="courses-feesm">
            <section class="course-fees" id="course-fees">
            <div class="row box-sh" >
                   <div class="col-sm-12 col-lg-12	col-xl-5  pd-fee" >
                        
                      </div>
                    <div class="vertical-line-fee"> </div>
                    <div class="col-sm-12 col-lg-12 col-xl-6 pd-fee">
                        <div class="row">
                            <div class="col-sm-10"> <br /><br />
                                <h5>Features</h5>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12 col-sm-12">
                              <ul class="highlight-ss" >
                                <li>	Indepth Coverage of Virtualization and Basic Networking.</li>
                                <li>	Indepth Coverage of Ethical Hacking.</li>
                                <li>	Indepth Coverage of Data/Information Security, Window Security.</li>
                                <li>	Hands on Assignments.</li>
                              </ul>
                            </div>
                            <p>{// eslint-disable-next-line
                               } <marquee onmouseover="this.stop();" onmouseout="this.start();" class="marquee-enroll" >"If a group of four or more participants enroll with us, a concession of 10% will be awarded to each one of them. For more details Contact us."<a href="tel://8956167195 " > &nbsp;&nbsp;<i class="fa fa-mobile" aria-hidden="true"></i> +91 8956167195</a></marquee>
                           </p>   
                        </div> 
                        </div>
                </div>
             </section> 
             </section> 
             
             <Whyedu/>
             <section class="course-about-instructor bg-secondary " id="course-about-instructor" >
                 <div class="row">
                     <div class="col-sm-12">
                         <h3>About the Instructor</h3>
                                 <br />
                                 <div class="about-ist">
                     <div class="card pd-abt-ist">
                        <div class="social-instructor">
                        <img  onerror="this.onerror=null;this.src='https://s3.ap-south-1.amazonaws.com/myeduplusnow/person/default_avatar.jpg';" alt="" src="https://s3.ap-south-1.amazonaws.com/myeduplusnow/person/25_IMG-20200107-WA0036.jpg" />
                        </div>
                        <div class="inst-details">
                        <h4>Seema Dixit</h4>
                            <p>16 Years Of Experience</p>
                            <br />
                            <h4>Freelancer</h4>
                            <p align="justify">Seema Dixit has over 16 years of experience in conducting training. She has trained more than 2000 students and professionals on various technologies like computer Networking, Operating System, Network Security, Ethical Hacking and Penetration Testing, Amazon Cloud Computing and Cybersecurity. She also has more than 10 years of experience in conducting training in security domains like Network Security, Ethical Hacking, Penetration Testing and Cybersecurity. She is Lead Security Trainer and Senior Security Analyst in IQSPL Pvt. Ltd., Pune and a Freelance trainer in Microsoft Server and Cisco Technologies, Amazon Cloud Computing, Ethical Hacking and Penetration Testing, and Cybersecurity.</p>
                           <br />
                           <ul class="course-about-ul">
                           <li >{// eslint-disable-next-line
                                    } <a href="#" target="_blank">
                                                <i class="fa fa-facebook" target="_blank" ></i>
                                            </a>
                                        </li>
                                        <li >{// eslint-disable-next-line
                                    }<a href="#"  target="_blank" >
                                                <i class="fa fa-linkedin" target="_blank"></i>
                                            </a>
                                        </li>
                                        <li >{// eslint-disable-next-line
                                    }<a href="#" target="_blank" >
                                                <i class="fa fa-twitter" target="_blank" ></i>
                                            </a>
                                        </li>
                                        <li>{// eslint-disable-next-line
                                    } <a href="#" target="_blank">
                                        <i class="fa fa-instagram" target="_blank"></i>
                                    </a></li>
                           </ul>
                        </div>
                     </div>
                  </div>
                  </div>
                  </div>
                  <div class="modal fade" id="myModalq" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog  modal-xl" role="document">
                    <div class="modal-content">
                        <div class="modal-body">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close"  onclick="stopvideo()">
                            <span class="colse-icon" aria-hidden="true">&times;</span>
                            </button>        
                            
                            <div class="embed-responsive embed-responsive-21by9">
                            <video controls="true" class="embed-responsive-item" id="video">
                                <source src="https://s3.ap-south-1.amazonaws.com/eduplusnowlive1/course/33/28/video/Introduction.mp4"  type="video/mp4" />
                            </video>
                            </div>
                        </div>
                    </div>
                </div>
                </div>
             </section> 

             <div class="modal fade bd-example-modal-sm" id="myModal" role="dialog">
                 <div class="modal-dialog modal-md">

                     <div class="modal-content">
                         <div class="modal-header" >
                             <span class="close" id="close_form"
                                     data-dismiss="modal">&times;</span>
                            <br />
                         </div>
                         <div class="modal-body" >
                             <div class="panel panel-default paper-shadow box_detail" >
                                 <h5 class="text-center "> Download The Course Brochure </h5>
                                 <form method="post" class="form-row"  onsubmit="return validate()">
                                     
                                 <b>Your Name</b><input class="form-control" pattern="[A-Za-z ]{1,32}" type="text"
                                         required="" autocomplete="on" name="name" id="name" />
                                     <b>Your email</b><input class="form-control" type="email" required=""
                                         autocomplete="on" name="emaill" id="emaill" />
                                     <b>Your Contact No</b><input class="form-control" pattern="[7-9]{1}[0-9]{9}"
                                         type="tel" required="" autocomplete="on" name="contactt" id="contactt" />
                                 <input type="hidden" name="id" id="exd-course-name" value='<?php echo $words[0]; ?>' />

                                     <input type="hidden" id="backurl" value="<?php echo $backurl?>" />
                                     <br />
                                     <div>
                                         <div class="form-group">
                                         <div  id="recaptcha" class="g-recaptcha"
                                             data-sitekey="6Lejh30UAAAAAPhZirvpXtobtIE80K7NUzsDqKjE"></div>
                                             <div id="captcha"></div>
                                         </div>
                                     </div>
                                     
                                    
                                     <div class="mob_cb">

                                         <div>
                                         </div><br />
                                       
                                          <button class="btn_1 rounded" type="button" onclick="getbroucher(<?php echo '\''.$filepath.'\'';?>)"  id="exd-download" ><i class="icon-download"></i> Brochure</button></div>
                                    
                                     <br />

                                     

                                 </form>
                             </div>
                         </div>
                     </div>

                 </div>

             </div>
     </div>


            
        );
    }
}

export default Onlinesybersecuritycertification;